import { RefreshCw, Ban, WifiOff, MessageCircle, type LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type G = { Icon: LucideIcon; title: string; desc: string };

const GUARANTEES: ReadonlyArray<G> = [
  {
    Icon: RefreshCw,
    title: 'Changement de plan à tout moment',
    desc: "Tu passes d'un plan à l'autre en 2 clics. La différence est calculée au prorata. Pas de blocage, pas de pénalité.",
  },
  {
    Icon: Ban,
    title: 'Annulation sans frais',
    desc: 'Tu stoppes quand tu veux depuis ton compte. Tes données restent accessibles jusqu’à la fin de la période payée, puis exportables.',
  },
  {
    Icon: WifiOff,
    title: 'Le mode offline est dans tous les plans',
    desc: "Même sur le plan Gratuit. C'est pas un bonus, c'est le cœur de Velko. Ta caisse marche avec ou sans réseau.",
  },
  {
    Icon: MessageCircle,
    title: 'Support FR, par des humains',
    desc: 'Pas de chatbot qui tourne en rond. Équipe à Dakar et Abidjan, fuseaux africains, on répond en moins de 24h sur Pro.',
  },
];

export default function PricingGuaranteesV2() {
  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <SectionLabel className="justify-center">Nos garanties</SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Zéro <span className="underline-lime">engagement caché</span>.
          </h2>
          <p className="mt-5 font-marketing-body text-lg text-charcoal-600">
            On te laisse faire marche arrière quand tu veux. Tes données restent les tiennes,
            exportables en un clic.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {GUARANTEES.map((g) => (
            <article
              key={g.title}
              className="flex flex-col border-2 border-charcoal-800 bg-white p-6 shadow-neobrutal-6 transition-transform hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-neobrutal-10"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-lime-500 shadow-neobrutal-2">
                <g.Icon className="h-5 w-5 text-charcoal-800" strokeWidth={2.2} />
              </span>
              <h3 className="mt-5 font-marketing-display text-[18px] font-bold leading-tight tracking-[-0.015em] text-charcoal-800">
                {g.title}
              </h3>
              <p className="mt-3 font-marketing-body text-[14.5px] leading-relaxed text-charcoal-600">
                {g.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
